export default "__VITE_ASSET__75da4c42__"